import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";
import { getCommonSearchList } from "../../services/settingsServices";
import { getVehiclePartsManagementList } from "../../services/VehicleService";
import ConfigDB from "../../config";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import DesmeImage from "../../asset/images/dismantle_icon.svg";
import moment from "moment";
import { getReservesDetails } from "../../services/PartsInventory";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getInternalSalesDetails } from "../../services/PartTypeService";

const VehiclePartMangement = ({
  setActiveTab,
  vehicleProcessList,
  vehicleId,
}) => {
  const { t } = useTranslation();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();
  const [vehicleManagementList, setVehicleManagementList] = useState([]);
  const [vehicleManagementData, setvehicleManagementData] = useState({
    part_management_type: 1,
  });
  const [vehiclePartsManagementList, setVehiclePartsManagementList] = useState(
    []
  );
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState("");
  const [modifyClientDetailsModal, setModifyClientDetailsModal] =
    useState(false);
  const [clientResDataDetails, setClientResDataDetails] = useState("");
  const [reserveDetails, setReserveDetails] = useState([]);
  const [modifyconverToSales, setModifyconverToSales] = useState(false);
  const [converToSalesDataList, setConverToSalesDataList] = useState("");
  const [internalSalesData, setInternalSalesData] = useState("");

  const handleClientDetailsOpen = (e, item) => {
    setClientResDataDetails(item);
    setModifyClientDetailsModal(true);
  };

  const handleClientDetailsClose = (e) => {
    setModifyClientDetailsModal(false);
  };

  const handleConvertToSaleOpen = (e, item) => {
    setConverToSalesDataList(item);
    setModifyconverToSales(true);
  };

  const handleConvertToSaleClose = () => {
    setModifyconverToSales(false);
  };

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
    }

    setParams(paramsObj);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "vehicle_management_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setVehicleManagementList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(
    function () {
      let data = {
        limit: 10,
        page: 1,
        search: search ? search : "",
        vehicle_id: vehicleProcessList?.vehicle_id
          ? vehicleProcessList?.vehicle_id
          : vehicleId,
        // vehicle_id: "96",
        part_management_type: vehicleManagementData?.part_management_type
          ? vehicleManagementData?.part_management_type
          : 1,
      };
      getVehiclePartsManagementList(data)
        .then((response) => {
          setVehiclePartsManagementList(response.data.data);
          setTotalRecords(response.data.total);
        })
        .catch((err) => {});
    },
    [vehicleManagementData, search]
  );

  useEffect(() => {
    if (clientResDataDetails?.reservation_uuid) {
      let data = {
        uuid: clientResDataDetails?.reservation_uuid,
      };
      getReservesDetails(data)
        .then((response) => {
          setReserveDetails(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [clientResDataDetails]);

  useEffect(() => {
    if (clientResDataDetails?.internal_sales_uuid) {
      let data = { uuid: clientResDataDetails?.internal_sales_uuid };
      getInternalSalesDetails(data)
        .then((response) => {
          setInternalSalesData(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [clientResDataDetails]);

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-primary">
            <Form method="post">
              <div className="card-body">
                <div className="row justify-content-start mt-4 mb-5 ms-1 me-1">
                  <React.Fragment>
                    <div className="col-md-12">
                      <div className="fileupload-content">
                       <div className="row justify-content-start">
                         <div className="col-md-6">
                        <FormGroup>
                          <Label className="col-form-label ms-2">
                            {t("vehicle_part_mangement")}
                          </Label>
                          <div className="col-xl-12">
                            <div className="input-div">
                              <Select
                                className="my-select-v"
                                options={vehicleManagementList}
                                value={vehicleManagementList.find(
                                  (option) =>
                                    option.value ===
                                    Number(
                                      vehicleManagementData.part_management_type ||
                                        1
                                    )
                                )}
                                onChange={(selectedOption) =>
                                  setvehicleManagementData({
                                    ...vehicleManagementData,
                                    part_management_type: selectedOption.value,
                                  })
                                }
                                placeholder={t("select_vehicle_part_management")}
                              />
                            </div>
                          </div>
                        </FormGroup>
                        </div>
                        <div className="col-md-6" style={{ marginTop: "45px" }}>
                      <div
                        className="card-title m-0 float-left"
                        style={{ width: "100%" }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder={t("search_by_internal_id")}
                        ></input>
                      </div>
                    </div>
                      </div>
                      </div>
                    </div>
                    
                    <div className="row">
                      <div className="col-md-12">
                        <div className="vehicleThBg table-responsive min-height-0 pb-2">
                          <table className="rounded-table table table-striped table-bordered table-hover">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>
                                  {t("internal_id")}
                                </th>
                                <th style={{ width: "10%" }}>{t("catalog")}</th>
                                <th style={{ width: "10%" }}>{t("make")}</th>
                                <th style={{ width: "10%" }}>{t("model")}</th>
                                <th style={{ width: "10%" }}>{t("year")}</th>
                                <th style={{ width: "10%" }}>
                                  {t("vehicle_variant_name")}
                                </th>
                                <th style={{ width: "10%" }}>{t("action")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              {vehiclePartsManagementList?.length > 0 ? (
                                vehiclePartsManagementList?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.parts_internal_id}</td>
                                      <td>{item?.namePartPT}</td>
                                      <td>{item.vehicle_model_name}</td>
                                      <td>{item.vehicle_make_name}</td>
                                      <td>{item.vehicle_year}</td>
                                      <td>{item.vehicle_variant_name}</td>
                                      <td>
                                        {(vehicleManagementData?.part_management_type ===
                                          1 ||
                                          vehicleManagementData?.part_management_type ===
                                            3) && (
                                          <button
                                            className="edit-btn"
                                            type="button"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (item) {
                                                navigate(
                                                  `/part/details/inven/${item.id}`,
                                                  {
                                                    state: {
                                                      ...item,
                                                      part_management_type: 1,
                                                    },
                                                  }
                                                );
                                              }
                                            }}
                                          >
                                            <img
                                              src={DesmeImage}
                                              style={{ width: "66%" }}
                                            />
                                          </button>
                                        )}

                                        {vehicleManagementData?.part_management_type ===
                                          2 && (
                                          <button
                                            className="edit-btn"
                                            type="button"
                                            onClick={(e) => {
                                              handleClientDetailsOpen(e, item);
                                            }}
                                          >
                                            <img
                                              src={DesmeImage}
                                              style={{ width: "66%" }}
                                            />
                                          </button>
                                        )}

                                        {vehicleManagementData?.part_management_type ===
                                          4 && (
                                          <button
                                            className="edit-btn"
                                            type="button"
                                            onClick={(e) => {
                                              handleConvertToSaleOpen(e, item);
                                            }}
                                          >
                                            <img
                                              src={DesmeImage}
                                              style={{ width: "66%" }}
                                            />
                                          </button>
                                        )}

                                        {vehicleManagementData?.part_management_type ===
                                          5 && (
                                          <button
                                            className="edit-btn"
                                            type="button"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (item) {
                                                navigate(
                                                  `/sales-details/${item.ecommerce_id}`,
                                                  {
                                                    state: {
                                                      ...item,
                                                      part_management_type: 5,
                                                    },
                                                  }
                                                );
                                              }
                                            }}
                                          >
                                            <img
                                              src={DesmeImage}
                                              style={{ width: "66%" }}
                                            />
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr className="scrollBrdr">
                                  <td colSpan={6}>{t("no_record_found")}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="card-footer clearfix card-footer-part fuelCF">
                        <div className="pagination pagination-sm m-0 float-right">
                          <ReactPaginate
                            previousLabel={
                              <i className="bi bi-chevron-double-left"></i>
                            }
                            nextLabel={
                              <i className="bi bi-chevron-double-right"></i>
                            }
                            breakLabel={"..."}
                            pageCount={Math.ceil(totalRecords / params.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => handleParams(e, "pagination")}
                            forcePage={params.page - 1}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                </div>
                <div className="back-footer">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <button
                        type="button"
                        className="next-button btn btn-secondary"
                        onClick={() => setActiveTab("vehicle_documents")}
                      >
                        <i className="bi bi-arrow-left"></i> {t("back")}
                      </button>
                    </div>
                    <div className="col-4 text-center">
                      <small style={{ color: "#9ca3af" }}>
                        {t("tool_label")}
                      </small>
                    </div>
                    <div className="col-4 text-end">
                      <button
                        type="button"
                        className="btn btn-primary nxt-btn"
                        onClick={() => setActiveTab("vehicle_part_check")}
                      >
                        {t("save_and_continue")}
                        <i className="bi bi-arrow-right ms-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>

        <Modal isOpen={modifyClientDetailsModal} size="xl">
          <ModalHeader className="modal-custom-header">
            {t("reserve_details")}
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row sales-detail-row"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <div className="col-md-4 col-sales">
                    {t("reservation_name")} :{reserveDetails?.reservation_name || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("packing_price")} :€ {reserveDetails?.packing_price || "-"}
                  </div>
                  <div className="col-md-4 col-sales">
                    {t("parcel_price")} : € {reserveDetails?.parcel_price || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("notes")} :{reserveDetails?.reservation_notes || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("reservation_end_date")}:
                    {reserveDetails?.reservation_end_date
                      ? moment(reserveDetails.reservation_end_date).format(
                          "YYYY-MM-DD HH:mm"
                        )
                      : "-"}{" "}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("total_price")} :€ {reserveDetails?.total_price || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="Label-my mb-2 mt-2">{t("client_details")}</div>
              </div>
              <div className="col-md-12">
                <div
                  className="row sales-detail-row"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <div className="col-md-4 col-sales">
                    {t("client_name")} :{reserveDetails?.client_name || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("email")}: {reserveDetails?.client_email || "-"}
                  </div>
                  <div className="col-md-4 col-sales">
                    {t("country_code")} :{reserveDetails?.client_country_code || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("district")} : {reserveDetails?.client_district || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("city")} : {reserveDetails?.client_city || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("bill_address")} :{reserveDetails?.client_bill_address || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("postal_code")} : {reserveDetails?.client_postal_code || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_country_code")}:{" "}
                    {reserveDetails?.client_vat_country_code || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_number")}: {reserveDetails?.client_vat_number || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_percentage")}:{" "}
                    {reserveDetails?.client_vat_percentage || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_exempt")}:{" "}
                    {reserveDetails?.client_is_vat_exempt === "1"
                      ? t("yes")
                      : t("no_label")}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("indicative_phone_code")}:{" "}
                    {reserveDetails?.client_indicative_phone_code}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("phone_code")}: {reserveDetails?.client_phone_number}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("whatsapp_number")}: {reserveDetails?.client_whatsapp_number}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="Label-my mb-2 mt-2">{t("shipping_address")}</div>
                <div
                  className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                  style={{
                    height: "150px",
                    minHeight: "150px",
                  }}
                >
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>{t("name")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {reserveDetails?.client_shipping_addresses?.length > 0 ? (
                        reserveDetails?.client_shipping_addresses?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item}</td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr className="scrollBrdr">
                          <td colSpan="100%">{t("no_results_found")}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-md-6">
                <div className="Label-my mb-2 mt-2">{t("part_details")}</div>
                <div
                  className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                  style={{
                    height: "150px",
                    minHeight: "150px",
                  }}
                >
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>{t("part_name")}</th>
                        <th>{t("warehouse_name")}</th>
                        <th>{t("sales_order_notes")}</th>
                        <th>{t("price")}</th>

                        <th>{t("action")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {reserveDetails?.part_list?.length > 0 ? (
                        reserveDetails?.part_list?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.namePartPT}</td>
                            <td>{item?.warehouse_name}</td>
                            <td>{item?.reservation_order_notes}</td>
                            <td>€ {item?.reserve_price}</td>

                            <td style={{ cursor: "pointer" }}>
                              <i
                                className="bi bi-eye-fill"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (item) {
                                    navigate(
                                      `/part/details/inven/${item.parts_id}`,
                                      {
                                        state: item,
                                      }
                                    );
                                  }
                                }}
                              ></i>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="scrollBrdr">
                          <td colSpan="100%">{t("no_results_found")}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleClientDetailsClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyconverToSales} size="xl">
          <ModalHeader className="modal-custom-header">
            {t("sales_details")}
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div
                  className="row sales-detail-row"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <div className="col-md-4 col-sales">
                    {t("sales_invoice_no")} :
                    {internalSalesData?.sales_invoice_no || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("total_part_price")} :€{" "}
                    {internalSalesData?.total_Part_price || "-"}
                  </div>
                  <div className="col-md-4 col-sales">
                    {t("sales_notes")} :{internalSalesData?.sales_notes || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("shipping_price")} :€ {internalSalesData?.shipping_price || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("parcel_price")} :€ {internalSalesData?.parcel_price || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("total_qty")} :{internalSalesData?.total_qty || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("total_vat_price")} :€{" "}
                    {internalSalesData?.total_vat_price || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("total_price")} :€ {internalSalesData?.total_price || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="Label-my mb-2 mt-2">{t("client_details")}</div>
              </div>
              <div className="col-md-12">
                <div
                  className="row sales-detail-row"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <div className="col-md-4 col-sales">
                    {t("client_name")} :{internalSalesData?.client_name || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("email")}: {internalSalesData?.client_email || "-"}
                  </div>
                  <div className="col-md-4 col-sales">
                    {t("country_code")} :
                    {internalSalesData?.client_country_code || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("district")} :{internalSalesData?.client_district || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("city")} :{internalSalesData?.client_city || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("bill_address")} :
                    {internalSalesData?.client_bill_address || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("postal_code")} : {internalSalesData?.client_postal_code || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_country_code")}:{" "}
                    {internalSalesData?.client_vat_country_code || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_number")}: {internalSalesData?.client_vat_number || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_percentage")}:{" "}
                    {internalSalesData?.client_vat_percentage || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("vat_exempt")}:{" "}
                    {internalSalesData?.client_is_vat_exempt === "1"
                      ? t("yes")
                      : t("no_label")}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("indicative_phone_code")}:{" "}
                    {internalSalesData?.client_indicative_phone_code || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("phone_code")}: {internalSalesData?.client_phone_number || "-"}
                  </div>

                  <div className="col-md-4 col-sales">
                    {t("whatsapp_number")}:{" "}
                    {internalSalesData?.client_whatsapp_number || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="Label-my mb-2 mt-2">{t("shipping_address")}</div>
                <div
                  className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                  style={{
                    height: "150px",
                    minHeight: "150px",
                  }}
                >
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>{t("name")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {internalSalesData?.client_shipping_addresses?.length >
                      0 ? (
                        internalSalesData?.client_shipping_addresses?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item}</td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr className="scrollBrdr">
                          <td colSpan="100%">{t("no_results_found")}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-md-6">
                <div className="Label-my mb-2 mt-2">{t("part_details")}</div>
                <div
                  className="vehicleThBg table-responsive tableScroll table-scroll-modal"
                  style={{
                    height: "150px",
                    minHeight: "150px",
                  }}
                >
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>{t("part_name")}</th>
                        <th>{t("warehouse_name")}</th>
                        <th>{t("sales_order_notes")}</th>
                        <th>{t("action")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {internalSalesData?.part_list?.length > 0 ? (
                        internalSalesData?.part_list?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.namePartPT}</td>
                            <td>{item?.warehouse_name}</td>
                            <td>{item?.internal_sales_order_notes}</td>
                            <td style={{ cursor: "pointer" }}>
                              <i
                                className="bi bi-eye-fill"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (item) {
                                    navigate(
                                      `/part/details/inven/${item.parts_id}`,
                                      {
                                        state: item,
                                      }
                                    );
                                  }
                                }}
                              ></i>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="scrollBrdr">
                          <td colSpan="100%">{t("no_results_found")}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleConvertToSaleClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default VehiclePartMangement;
